import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export const Proof = () => {
  return <AnimatedSection className="bg-ink text-paper border-y border-ink" data-id="element-138">
      <div className="mb-12 text-center" data-id="element-139">
        <span className="uppercase tracking-widest text-xs font-semibold text-paper/50 block mb-4" data-id="element-140">
          LOS NÚMEROS
        </span>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-141">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-142">
          <div className="space-y-2 border-l-2 border-accent pl-6" data-id="element-143">
            <p className="text-4xl md:text-5xl font-serif text-accent" data-id="element-144">1-3</p>
            <p className="font-sans text-paper/80 uppercase tracking-wider text-sm" data-id="element-145">
              citas diarias
            </p>
          </div>
          <div className="space-y-2 border-l-2 border-accent pl-6" data-id="element-146">
            <p className="text-4xl md:text-5xl font-serif text-accent" data-id="element-147">
              $50-$100 USD
            </p>
            <p className="font-sans text-paper/80 uppercase tracking-wider text-sm" data-id="element-148">
              por venta cerrada
            </p>
          </div>
        </div>

        <blockquote className="text-xl md:text-2xl font-sans leading-relaxed text-paper/90 text-center mb-12 max-w-3xl mx-auto" data-id="element-149">
          "Un Appointment Setter novato puede agendar entre 1 y 3 citas diarias
          con el volumen correcto. En una agencia High Ticket, una sola venta
          cerrada puede significar una comisión de $50 a $100 USD para vos."
        </blockquote>

        <div className="text-center border-t border-paper/20 pt-12" data-id="element-150">
          <p className="text-3xl md:text-4xl font-serif italic text-accent" data-id="element-151">
            ¿Cuántas de esas necesitás para duplicar tu sueldo actual?
          </p>
        </div>
      </div>
    </AnimatedSection>;
};